var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-\\uD83D\\uDD0E-Search-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Style-Guide",
    transform: "translate(-59.000000, -796.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico/arrow",
    transform: "translate(58.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99973326,10.1504401 C4.99973326,9.91704455 5.09975994,9.70098693 5.26647106,9.53427581 L8.00053348,7.00026674 L2.00026674,7.00026674 C1.4001067,7.00026674 1,6.60016004 1,6 C1,5.39983996 1.4001067,5.00106695 2.00026674,5.00106695 L8.00053348,5.00106695 L5.23312883,2.43371566 C5.08242198,2.28434249 4.99973326,2.05094692 4.99973326,1.84955988 C4.99973326,1.38410243 5.43318218,1 5.8666311,1 C6.10002667,1 6.31608429,1.10002667 6.46679114,1.25073353 L10.69992,5.39983996 C10.8666311,5.56655108 11,5.76660443 11,6 C11,6.2173913 10.8506268,6.45078688 10.69992,6.60016004 L6.48279541,10.7332622 C6.28274206,10.9333156 6.06668445,11 5.8666311,11 C5.38383569,11 4.99973326,10.6172313 4.99973326,10.1504401",
    id: "Fill-1",
    fill: "#858199",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/iconArrow.aecd4e6e.svg";
export { ForwardRef as ReactComponent };